<div class="container"
  #container
  *ngIf="activeObservable | async"
  [@fade]
>
  <div class="container__content">
    <ng-content></ng-content>
  </div>
</div>
